// src/Helpers/format/formatNumber.ts

/**
 * Formats a number according to Danish number formatting standards (e.g., 1.000,50).
 *
 * If the input is null, undefined, an empty string, or not a valid number,
 * a dash ('-') is returned instead.
 *
 * @param number - The numeric value to format (can be number, string, null, or undefined).
 * @returns A formatted number string or a dash ('-') if invalid.
 */

export const formatNumber = (number: number | string | null | undefined): string => {
  if (number === undefined || number === null || number === '') {
    return '-';
  }

  const parsedNumber = typeof number === 'string' ? parseFloat(number) : number;

  if (isNaN(parsedNumber)) {
    return '-';
  }

  return new Intl.NumberFormat('da-DK', {
    style: 'decimal',
    minimumFractionDigits: 2,
    minimumIntegerDigits: 1,
  }).format(parsedNumber);
};
